import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'components/Button';
import Flex from 'components/Flex';
import FormField from 'components/FormField';
import Spinner from 'components/Spinner';
import { TeamPill } from 'components/Pill';
import InlineList from 'components/InlineList';
import Text from 'components/Text';
import OwningTeamPickerModal from 'components/OwningTeamPickerModal';
import OwningTeamConfirmationModal from './OwningTeamConfirmationModal';
import { useFetchTeamById } from 'actions/team';
import { useUpdateAssets } from 'actions/assets';
var OwningTeamField = function OwningTeamField(_ref) {
  var ownerTeamId = _ref.ownerTeamId,
    contentId = _ref.contentId,
    onChange = _ref.onChange,
    onDeleteOwningTeam = _ref.onDeleteOwningTeam;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showTeamSelectorModal = _useState2[0],
    setShowTeamSelectorModal = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showConfirmationDeletionModal = _useState4[0],
    setShowConfirmationDeletionModal = _useState4[1];
  var _useFetchTeamById = useFetchTeamById({
      teamIds: ownerTeamId ? [ownerTeamId] : []
    }),
    isFetchTeamLoading = _useFetchTeamById.isLoading,
    items = _useFetchTeamById.items;
  var owningTeam = items[0];
  var selectNewTeam = function selectNewTeam(teamSelection) {
    onChange(teamSelection);
    setShowTeamSelectorModal(false);
  };
  var _useUpdateAssets = useUpdateAssets({
      assetIds: contentId ? [contentId] : []
    }),
    updateAssets = _useUpdateAssets.updateAssets;
  var onDelete = function onDelete() {
    updateAssets({
      ownerTeamId: null
    });
    onDeleteOwningTeam();
    setShowConfirmationDeletionModal(false);
  };
  return /*#__PURE__*/React.createElement(FormField, {
    as: "fieldset",
    label: t('form_owning_team'),
    horizontal: true,
    descriptionType: "tooltip",
    description: t('panel_owning_team_description_asset')
  }, /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(InlineList, {
    spacing: "xxs"
  }, isFetchTeamLoading ? /*#__PURE__*/React.createElement(Spinner, null) : owningTeam ? /*#__PURE__*/React.createElement(TeamPill, {
    key: owningTeam.id,
    team: owningTeam,
    deleteLabel: t('actions_remove_owning_team'),
    onDelete: function onDelete() {
      return setShowConfirmationDeletionModal(true);
    }
  }) : /*#__PURE__*/React.createElement(Text, {
    dimmed: true,
    size: "s"
  }, t('amount_none')), /*#__PURE__*/React.createElement(Button, {
    size: "small",
    variant: "transparent",
    onClick: function onClick() {
      return setShowTeamSelectorModal(true);
    },
    "aria-label": t('actions_change_owning_team')
  }, t('actions_change')))), showTeamSelectorModal && /*#__PURE__*/React.createElement(OwningTeamPickerModal, {
    defaultSelectedItems: owningTeam ? [owningTeam] : [],
    onClose: function onClose() {
      return setShowTeamSelectorModal(false);
    },
    onSubmit: selectNewTeam,
    contentIds: [contentId]
  }), showConfirmationDeletionModal && /*#__PURE__*/React.createElement(OwningTeamConfirmationModal, {
    isMultiSelect: false,
    onCancel: function onCancel() {
      return setShowConfirmationDeletionModal(false);
    },
    onConfirm: function onConfirm() {
      return onDelete();
    }
  }));
};
export default OwningTeamField;